import { Typography, Box, } from "@mui/material";

import { Available } from "../../utils/booking";
import { LoadingButton } from "@mui/lab";

const Slots = ({
  slots,
  caption,
  submitting,
  handleSelectSlot,
  verifying
}: {
  slots: Available[];
  caption: string;
  submitting:boolean;
  verifying:boolean;
  // eslint-disable-next-line no-unused-vars
  handleSelectSlot: (params: Available) => void;
  // tz: string;
}) => {
  if (slots.length === 0) return null;

  return (
    <Box>
      <Typography variant="caption" align="center" color="primary">
        {caption}
      </Typography>

      <Box
        sx={{
          display: "grid",
          width: "100%",
          rowGap: 0.5,
          columnGap: 0.5,
          marginLeft: "auto",
          boxSizing: "border-box",
          marginRight: "auto",
          gridTemplateColumns: {
            xs: "repeat(3, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        {slots?.map((slot: Available, idx: number) => (
          <LoadingButton
            variant="contained"
            key={`idx-${idx}`}
            loading={submitting || verifying}
            sx={{
              p: 0.5,
              m: 0.5,
              heigh: "4rem",
              minHeight: { xs: "2.5rem", sm: "auto" },
              background: "#fff",
              fontFamily: "ABCDiaTypeRegular",
              border: 1,
              borderColor: "#725E54",
              // borderColor: "text.primary",
              fontSize: "1rem",
              color: "text.primary",
              boxShadow: "1px 1px 6px 0 rgb(0 0 0 / 10%)",
              "&:hover": {
                backgroundColor: "#98A481",
                border: "none",
                color: "#fff",
              },
            }}
            onClick={() => handleSelectSlot(slot)}
            color={"primary"}
          >
            {slot.time}
          </LoadingButton>
        ))}
      </Box>
    </Box>
  );
};

export default Slots;
